
import { defineComponent, SetupContext } from 'vue'

export default defineComponent({
  name: 'InputCheckBoxSimple',

  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    name: {
      type: String
    },
    checked: {
      type: Boolean,
      default: false
    }
  },

  setup(props: any, context: SetupContext) {
    const emit = (e: any) => {
      context.emit('call-input-change', {
        value: e.target.value,
        checked: e.target.checked
      })
    }
    return {
      emit
    }
  }
})
